module.exports = __webpack_public_path__ + "img/10_66.4c6064e8.png";